<template>
  <div class="ForeignHealthInsuranceTypeForm">
    <h2 class="gl_form-title">
      {{ t('health-foreign.insurance-type.legend') }}
    </h2>

    <RadioButtonGroup
      id="type"
      :value="insuranceType"
      :options="insuranceOptions"
      v-model="insuranceType"
      :rules="[validationRules.required]"
    />
  </div>
</template>

<script lang="ts" setup>
  import { computed, ref } from 'vue'
  import { useI18n } from 'vue-i18n'
  import RadioButtonGroup from '@/modules/core/components/ui/RadioButtonGroupComponent.vue'
  import type ForeignHealthConfigurations from '@/modules/foreign-health/common/models/APP/ForeignHealthConfigurations'
  import { useRules } from '@/modules/core/composables/useRulesComposable'
  import type ForeignHealthRaterAnswers from '../../models/APP/ForeignHealthRaterAnswers'

  const { t } = useI18n()
  const { required } = useRules()

  defineExpose({ triggerSubmit })
  interface PropsInterface {
    nextForm: String[]
    answers: ForeignHealthRaterAnswers
    configurations: ForeignHealthConfigurations
  }
  const props = withDefaults(defineProps<PropsInterface>(), {})

  const insuranceOptions = computed(() => props.configurations.insuranceTypesOptions)
  const insuranceType = ref(
    String(props.answers.insuranceType) ?? props.configurations.defaultInsuranceType
  )

  const validationRules = {
    required
  }

  function getStayAbroadType(insuranceTypeValue: string) {
    if (insuranceTypeValue === props.configurations.insuranceTypes.student.id) {
      return '3'
    }
    if (insuranceTypeValue === props.configurations.insuranceTypes.resident.id) {
      return '4'
    }
    return ''
  }

  function getNextPage() {
    if (insuranceType.value === props.configurations.insuranceTypes.student.id) {
      return props.nextForm[0]
    }
    return props.nextForm[1]
  }

  function triggerSubmit() {
    const page = getNextPage()
    const selectedInsuranceType = insuranceType.value
    const stayAbroadType = getStayAbroadType(selectedInsuranceType)

    const answers = {
      insuranceType: selectedInsuranceType,
      stayAbroadType
    }

    return { page, answers }
  }
</script>

<style lang="scss" scoped>
  .gl_form-title {
    margin-bottom: $spacing-xl;
  }
</style>
